import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import UserList from './pages/UserList';
import Settings from './pages/Settings';
import Login from './pages/Login';

const navStyle: React.CSSProperties = {
  display: 'flex',
  gap: '16px',
  padding: '16px 24px',
  borderBottom: '1px solid #e0e0e0',
  background: '#fff',
  alignItems: 'center',
};

const linkStyle = ({ isActive }: { isActive: boolean }): React.CSSProperties => ({
  textDecoration: 'none',
  color: isActive ? '#1976d2' : '#666',
  fontWeight: isActive ? 700 : 400,
  fontSize: '15px',
  padding: '8px 16px',
  borderRadius: '6px',
  background: isActive ? '#e3f2fd' : 'transparent',
});

export default function App() {
  const [loggedIn, setLoggedIn] = useState(() => sessionStorage.getItem('loggedIn') === 'true');

  const handleLogin = () => {
    sessionStorage.setItem('loggedIn', 'true');
    setLoggedIn(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('loggedIn');
    setLoggedIn(false);
  };

  if (!loggedIn) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <BrowserRouter>
      <div style={{ fontFamily: "'Segoe UI', sans-serif", minHeight: '100vh', background: '#f5f5f5' }}>
        <nav style={navStyle}>
          <NavLink to="/" style={linkStyle} end>사용자 목록</NavLink>
          <NavLink to="/settings" style={linkStyle}>설정</NavLink>
          <button
            onClick={handleLogout}
            style={{
              marginLeft: 'auto',
              padding: '6px 16px',
              background: 'none',
              border: '1px solid #ccc',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '13px',
              color: '#666',
            }}
          >
            로그아웃
          </button>
        </nav>
        <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
          <Routes>
            <Route path="/" element={<UserList />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}
